import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACS_SupervisionForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACS_SupervisionForm' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>	Name of Trainee/Supervisee: </span>
                            <input type="text" id="txtName" name="txtName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>	Month of Supervision: </span>
                            <input type="text" id="txtSupervision" name="txtSupervision" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Supervisor: (include credentials)</span>
                            <input type="text" id="txtSupervisor" name="txtSupervisor" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Total Hours: </span>
                            <input type="text" id="txtTotal" name="txtTotal" className='add-only' />
                        </td>
                    </tr>
                </table>

                <span className='eleHeader'>	Supervision Processes</span>
                <table>
                    <tr>
                        <td className='w-250'> <input type="checkbox" id="cbSupervisionProcesses_1" name="cbSupervisionProcesses_1" className='add-only' value="Teaching/Education" /> Teaching/Education</td>
                        <td className='w-250'> <input type="checkbox" id="cbSupervisionProcesses_2" name="cbSupervisionProcesses_2" className='add-only' value="Case Discussion" /> Case Discussion</td>
                        <td className='w-250'> <input type="checkbox" id="cbSupervisionProcesses_3" name="cbSupervisionProcesses_3" className='add-only' value="Role Playing" /> Role Playing</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type="checkbox" id="cbSupervisionProcesses_5" name="cbSupervisionProcesses_5" className='add-only' value="Record/Documentation Review" /> Record/Documentation Review</td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type="checkbox" id="cbSupervisionProcesses_6" name="cbSupervisionProcesses_6" className='add-only' value="Other" /> Other (Specify):
                            <input type="text" id="txtOther_1" name="txtOther_1" className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'> <input type="checkbox" id="cbSupervisionProcesses_7" name="cbSupervisionProcesses_7" className='add-only' value="Individual" /> Individual</td>
                        <td className='w-250'> <input type="checkbox" id="cbSupervisionProcesses_8" name="cbSupervisionProcesses_8" className='add-only' value="Group" /> Group</td>
                        <td className='w-250'> <input type="checkbox" id="cbSupervisionProcesses_9" name="cbSupervisionProcesses_9" className='add-only' value="Client and Staff" /> Client and Staff</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type="checkbox" id="cbSupervisionProcesses_10" name="cbSupervisionProcesses_10" className='add-only' value="Phone" /> Phone</td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type="checkbox" id="cbSupervisionProcesses_11" name="cbSupervisionProcesses_11" className='add-only' value="Other" /> Other (Specify):
                            <input type="text" id="txtOther_2" name="txtOther_2" className='add-only' />
                        </td>
                    </tr>
                </table>

                <span className='eleHeader'>Review Topics</span>
                <table>
                    <tr>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_1" name="cbReviewTopics_1" className='add-only' value="Linking and accessing" /> Linking and accessing</td>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_2" name="cbReviewTopics_2" className='add-only' value="Advocating" /> Advocating</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_3" name="cbReviewTopics_3" className='add-only' value="Skill building/intervention strategies" /> Skill building/intervention strategies</td>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_4" name="cbReviewTopics_4" className='add-only' value="Utilizing the team approach" /> Utilizing the team approach</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_5" name="cbReviewTopics_5" className='add-only' value="Cultural competence" /> Cultural competence</td>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_6" name="cbReviewTopics_6" className='add-only' value="Documentation" /> Documentation</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_7" name="cbReviewTopics_7" className='add-only' value="Clinical Skills" /> Clinical Skills</td>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_8" name="cbReviewTopics_8" className='add-only' value="Communication Skills" /> Communication Skills</td>
                    </tr>
                    <tr>

                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_9" name="cbReviewTopics_9" className='add-only' value="Interviewing skills" /> Interviewing skills</td>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_10" name="cbReviewTopics_10" className='add-only' value="Evidence-based approaches" /> Evidence-based approaches</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_11" name="cbReviewTopics_11" className='add-only' value="Person-Cantered plan" /> Person-Cantered plan</td>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_12" name="cbReviewTopics_12" className='add-only' value="Special Populations" /> Special Populations</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_13" name="cbReviewTopics_13" className='add-only' value="Decision Making Skills" /> Decision Making Skills</td>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_14" name="cbReviewTopics_14" className='add-only' value="Analytical Skills" /> Analytical Skills</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_15" name="cbReviewTopics_15" className='add-only' value="Professional values/ethics" /> Professional values/ethics</td>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_16" name="cbReviewTopics_16" className='add-only' value="Systems issues" /> Systems issues</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type="checkbox" id="cbReviewTopics_17" name="cbReviewTopics_17" className='add-only' value="Safety (consumer and employee) and self care" /> Safety (consumer and employee) and self care</td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type="checkbox" id="cbReviewTopics_18" name="cbReviewTopics_18" className='add-only' value="Assessing service provision and determining progress" /> Assessing service provision and determining progress</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type="checkbox" id="cbReviewTopics_19" name="cbReviewTopics_19" className='add-only' value="Other" /> Other:</td>
                    </tr>
                </table>

                <p>
                    <textarea id="txtOther_3" name="txtOther_3" className='add-only' ></textarea>
                </p>

                <p>
                    <span className='eleHeader'>	Areas Identified for Development</span>
                    <textarea id="txtDevelopment" name="txtDevelopment" className='add-only' ></textarea>
                </p>

                <p>
                    <span className='eleHeader'>	Comments</span>
                    <textarea id="txtComments" name="txtComments" className='add-only' ></textarea>
                </p>

                <h4>Attestation:</h4>
                <span>The signatures below confirm that the trainee/supervisee listed above is:(check one)</span>
                <table>
                    <tr>
                        <td><input type="checkbox" id="cbAttestation_1" name="cbAttestation_1" className='add-only' value="Enrolled in course which provides education hours toward CAC" /> Enrolled in course which provides education hours toward CAC</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" id="cbAttestation_2" name="cbAttestation_2" className='add-only' value="Enrolled in a practicum with an accredited educational Master's degree program which provides supervision as a part of a curriculum which is the foundation toward licensure" /> Enrolled in a practicum with an accredited educational Master's degree program which provides supervision as a part of a curriculum which is the foundation toward licensure</td>
                    </tr>
                    <tr>
                        <td> <h3>OR</h3></td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" id="cbAttestation_3" name="cbAttestation_3" className='add-only' value="Received supervision towards licensure in accordance with O.C.G.A. 43-10A-3" /> Received supervision towards licensure in accordance with O.C.G.A. 43-10A-3</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className="small w-375">Supervisor Print
                        </td>
                        <td className="small w-375">Signature Date
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className="small w-375">Trainee/Supervisee Print
                        </td>
                        <td className="small w-375">Signature Date
                        </td>
                    </tr>
                </table>







            </div>
        </form>

    )
}    